import { AppSidebar } from "@/components/AppSidebar";
import { MobileTopBar } from "@/components/MobileTopBar";
import { SuperAdminDock } from "@/components/SuperAdminDock";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { Outlet } from "@tanstack/react-router";

export function DashboardLayout() {
  return (
    <SidebarProvider className="h-svh overflow-hidden">
      <AppSidebar />
      <SidebarInset className="min-h-0">
        <MobileTopBar />
        <main className="flex flex-1 flex-col min-h-0 overflow-auto">
          <Outlet />
        </main>
      </SidebarInset>
      <SuperAdminDock />
    </SidebarProvider>
  );
}
